// extracted by mini-css-extract-plugin
export default {"sectionCinemas":"Cinemas_sectionCinemas__v8oq+","list-title":"Cinemas_list-title__Znymk","dropDownLayout":"Cinemas_dropDownLayout__811zV"};